import React, { useEffect, useMemo, useState } from 'react';
import countries from './phoneCountries.json';

const codeFor = country => countries.find(([iso]) => iso === country)?.[1] || '1';
const flag = country => String.fromCodePoint(...[...country].map(letter => 127397 + letter.charCodeAt(0)));
export function internationalNumber(country, local) {
  const raw = String(local || '').trim();
  if (raw.startsWith('+')) return '+' + raw.slice(1).replace(/\D/g, '');
  let digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  const code = codeFor(country);
  if (code === '1' && digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  return '+' + code + digits;
}

export default function InternationalPhoneField({value = '', onChange, disabled, lang = 'en', className = ''}) {
  const [country, setCountry] = useState('US');
  const copy = ({pt:{country:'País do telefone',number:'Telefone',hint:'O código do país é acrescentado automaticamente.'},es:{country:'País del teléfono',number:'Teléfono',hint:'El código del país se añade automáticamente.'},en:{country:'Phone country',number:'Phone number',hint:'The country calling code is added automatically.'}})[lang] || {country:'Phone country',number:'Phone number',hint:'The country calling code is added automatically.'};
  const options = useMemo(()=>{
    let names;
    try { names = new Intl.DisplayNames([lang], {type:'region'}); } catch { names = null; }
    return countries.map(([iso,code])=>({iso,code,name:names?.of(iso)||iso})).sort((a,b)=>a.iso==='US'?-1:b.iso==='US'?1:a.name.localeCompare(b.name,lang));
  },[lang]);
  useEffect(()=>{
    if (!value.startsWith('+') || value.startsWith('+'+codeFor(country))) return;
    const match = [...countries].sort((a,b)=>b[1].length-a[1].length).find(([,code])=>value.startsWith('+'+code));
    if (match) setCountry(match[0]);
  },[value,country]);
  const prefix = '+' + codeFor(country);
  const local = value.startsWith(prefix) ? value.slice(prefix.length) : value.startsWith('+') ? value.slice(1) : value;
  return <div className="space-y-2">
    <div className="grid grid-cols-1 sm:grid-cols-[minmax(150px,1fr)_2fr] gap-3">
      <label>{copy.country}<select className={className} value={country} disabled={disabled} onChange={e=>{setCountry(e.target.value);onChange(internationalNumber(e.target.value,local));}} autoComplete="tel-country-code">{options.map(option=><option key={option.iso} value={option.iso}>{flag(option.iso)} {option.name} +{option.code}</option>)}</select></label>
      <label>{copy.number}<span className="flex items-center gap-2"><span aria-hidden="true">{prefix}</span><input className={className} name="phone" type="tel" inputMode="tel" autoComplete="tel-national" placeholder={country==='US'?'(510) 555-0123':''} value={local} maxLength={30} disabled={disabled} required onChange={e=>onChange(internationalNumber(country,e.target.value))}/></span></label>
    </div>
    <p className="text-sm text-zinc-400">{copy.hint}</p>
  </div>;
}
